import React from "react";
import logo from "../../assets/logo.png";
import "./header.css";
import "../../styles/globalstyle.css";
import { Link } from "react-router-dom";
const Header = () => {
  return (
    <div className="boxShadow">
      <div className="headercontainer container ">
        <div>
          <Link 
          style={{ textDecoration: "none", color: "#000" }}
          
          to={"/"}>
            <img src={logo} alt="" />
            <h5 className="rate">Rate</h5>
          </Link>
        </div>

        <Link
          to={"/feedback"}
          style={{ textDecoration: "none", color: "#000" }}
        >
          <p className="link">Feedback</p>
        </Link>
      </div>
    </div>
  );
};

export default Header;
